var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from 'react';
var initialState = {
    children: null,
    canClose: false
};
var ModalContext = createContext(initialState);
var ModalProvider = function (props) {
    var children = props.children;
    var _a = __read(useState(initialState), 2), modal = _a[0], setModal = _a[1];
    var value = {
        canClose: modal.canClose,
        children: modal.children,
        openModal: function (component, canClose) {
            if (canClose === void 0) { canClose = false; }
            setModal(__assign(__assign({}, modal), { canClose: canClose, children: component }));
        },
        closeModal: function (forceClose) {
            if (forceClose === void 0) { forceClose = false; }
            if (!forceClose && !modal.canClose)
                return;
            setModal(__assign(__assign({}, modal), { children: null }));
        },
    };
    return _jsx(ModalContext.Provider, { value: value, children: children });
};
export { ModalProvider, ModalContext, };
//# sourceMappingURL=modal.provider.js.map